<template>
  <div class="mt-3 font-17">
    <!-- <div > -->
    <b-row v-for="course_lessons in lessons" :key="course_lessons.id">
      <b-col>
        <b-col class="align-items-center" lg="12">
          <div class="lesson-topic py-1 my-1" v-if="course_lessons.type === 'divide'">
            <b class="mt-1 mx-2">{{ course_lessons.name }}</b>
          </div>
          <div v-if="course_lessons.type === 'lesson'" class="pointer text-primary-100 my-1 py-1"
            style=" box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1),0 -1px 3px rgba(0, 0, 0, 0.1);;border-radius: 5px;">
            <div @click="
              enrollCheck
                ? lessonDetail(course_lessons, course_lessons.subject_id,lessonProgress)
                : showEnrollAlert()
              " :class="!(selected && selected.id == course_lessons.id)
              ? 'row '
              : 'row lesson-bar'
              " :style="preTestCheck(course_lessons)
                ? 'opacity: 0.5; cursor: not-allowed;'
                : ''
                ">
              <div class="col-6 col-md-7  d-flex align-items-center" style="padding-left: 30px;">
                {{ course_lessons.name.includes("บทเรียน") ? "" : "บทเรียน " }}
                {{ course_lessons.name }}
              </div>

              <div class="d-flex flex-wrap justify-content-center justify-content-md-start align-items-center col-5 p-0">
                <b-icon v-if="checkLessonProgress(course_lessons.id)" icon="eye" class="close mx-2"
                  style="color: green"></b-icon>
                <div class="d-flex align-items-center p-0 pl-lg-3">
                  <i :class="!(selected && selected.id == course_lessons.id)
                    ? 'bi bi-pause-circle mr-2 font-25'
                    : 'bi bi-play-circle mr-2 font-25'
                    "></i>
                  <span class="my-auto">
                    {{ convertTominute(course_lessons.lesson_minute) }}
                  </span>
                </div>
                <div style="min-width: 145px;" class="px-3 ">
                  <template v-if="course_lessons.pdf">
                    <button @click.stop="downloadFile(course_lessons.pdf.url)" :disabled="preTestCheck(course_lessons)"
                      class="btn btn-sm btn-light btn-block pill-btn " :style="preTestCheck(course_lessons) 
                        ? 'white-space: nowrap; cursor: not-allowed;'
                        : 'white-space: nowrap;'
                        " style="border: 1px solid #00264E !important;border-radius: 10px;">
                      Download เอกสาร
                    </button>
                  </template>
                </div>
              </div>

            </div>
          </div>

          <div v-if="
            course_lessons.type === 'quiz' || course_lessons.type === 'eval'
          " class="pointer text-primary-100 my-1 py-1"
            style="box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1),0 -1px 3px rgba(0, 0, 0, 0.1);;border-radius: 5px;">
            <div @click="
              enrollCheck
                ? goToQuiz(
                  course_lessons.question_sets,
                  answerCourse,
                  course_lessons.question_sets.repeatable,
                  course_lessons.question_sets.repeat_number,
                  getAnswerOfLessonbyid(course_lessons, answerCourse)
                )
                : showEnrollAlert()" :class="!(selected && selected.id == course_lessons.id)
                ? 'row '
                : 'row lesson-bar '
                ">
              <!-- ชื่อบททดสอบหรือแบบประเมิน -->
              <div class="col-6 col-md-7 d-flex align-items-center" style="padding-left: 30px;">
                {{
                  course_lessons.question_sets.test_type == "pretest"
                    ? "(Pre Test)"
                    : course_lessons.question_sets.test_type == "posttest"
                      ? "(Post Test)"
                      : ""
                }}
                {{ course_lessons.name }}
              </div>

              <div class="d-flex align-items-center col-5 p-0">

                <div style="min-width: 120px" v-if="courseEnroll">
                  <button :disabled="!inTimeDuration(
                    courseEnroll.enroll
                      ? courseEnroll.enroll.course_start || null
                      : null,
                    courseEnroll.enroll
                      ? courseEnroll.enroll.course_end || null
                      : null
                  ) ||
                    postTestCheck(course_lessons.question_sets) ||
                    numtest(
                      course_lessons.question_sets.repeatable,
                      course_lessons.question_sets.repeat_number,
                      getAnswerOfLessonbyid(course_lessons, answerCourse)
                    )
                    " class="btn btn-outline-light text-primary-100" :style="'min-width: 125px;'">
                    <i class="bi bi-pencil"></i>
                    {{
                      course_lessons.type === "quiz" ? "แบบทดสอบ" : "แบบประเมิน"
                    }}
                  </button>
                </div>

                <div style="min-width: 145px">
                  <div class="my-auto" v-if="course_lessons.type != 'eval'">
                    <div class="d-flex my-auto ">
                      <div v-if="getAnswerOfLesson(course_lessons, answerCourse)">
                        <div v-if="
                          getAnswerOfLesson(course_lessons, answerCourse)
                            .is_checking
                        " :style="`color:  ${course_lessons.question_sets
                        ? getAnswerOfLesson(course_lessons, answerCourse)
                          .user_score >=
                          getMaxQuestion(course_lessons, answerCourse)
                          ? 'green'
                          : 'red'
                        : 'gray'
                        };`">

                          คะแนนสอบ :
                          {{
                            getAnswerOfLesson(course_lessons, answerCourse)
                              .user_score
                          }}
                          /
                          {{ getMaxQuestion(course_lessons, answerCourse) }}
                        </div>
                        <div v-else>กำลังตรวจ..</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </b-col>
      </b-col>
    </b-row>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      scor: null,
    };
  },
  props: {
    lessons: null,
    selected: null,
    courseStatus: null,
    answerCourse: null,
    lessonProgress: null,
    enrollCheck: Boolean,
  },
  computed: {
    ...mapState({
      userData: (state) => state.Auth.userData,
      course: (state) => {
        return state.Courses.course;
      },
      courseEnroll: (state) => {
        return state.Courses.courseEnroll;
      },
      courses: (state) => {
        return state.Courses;
      },
    }),
  },
  mounted() { },
  methods: {
    showEnrollAlert() {
      if (!this.userData || !this.userData.id) {
        Swal.fire({
          title: "กรุณาเข้าสู่ระบบ",
          text: "โปรดเข้าสู่ระบบและสมัครเรียนก่อนเข้าสู่บทเรียน",
          icon: "warning",
          confirmButtonText: "เข้าสู่ระบบ",
          confirmButtonColor: "#2778c4",
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push({ path: "/login" });
          }
        });
        return;
      }

      Swal.fire({
        title: "กรุณาสมัครเรียนก่อน",
        text: "เนื้อหาส่วนนี้ สำหรับผู้ที่ลงทะเบียนเรียนเท่านั้น",
        icon: "warning",
        confirmButtonText: "ตกลง",
        confirmButtonColor: "#2778c4",
      });
    },
    checkLessonProgress(lessonId) {
      if (!this.lessonProgress) {
        return false;
      }

      const lesson = this.lessonProgress.find(
        (lesson) => lesson.lesson_id == lessonId
      );

      if (!lesson) {
        return false;
      }

      return lesson.status == 1;
    },
    testInTimeText(startTimeString, duration) {
      if (!startTimeString) {
        return null;
      }

      const startTime = moment(startTimeString);
      const endTime = moment(startTimeString).add(duration, "minutes");
      const now = moment();

      if (now >= startTime && now <= endTime) {
        return null;
      } else {
        if (now < startTime) {
          return `เริ่มเวลาสอบ ${startTime.format(`DD/MM/Y HH:mm:ss`)}`;
        } else if (now > endTime) {
          return `หมดเวลาสอบ`;
        } else {
          return `เริ่มเวลาสอบ ${startTime.format(`DD/MM/Y HH:mm:ss`)}`;
        }
      }
    },
    inTimeDurationWithMinute(startTimeString, duration) {
      if (!startTimeString) {
        return true;
      }
      const startTime = moment(startTimeString);
      const endTime = moment(startTimeString).add(duration, "minutes");
      const now = moment();
      return now.isBetween(startTime, endTime);
      // return now >= startTime && now <= endTime;
    },
    inTimeDuration(startTimeString, endTimeString) {
      if (!startTimeString) {
        return true;
      }
      const startTime = moment(startTimeString);
      const endTime = moment(endTimeString);
      const now = moment();
      return now.isBetween(startTime, endTime);
      // return now >= startTime && now <= endTime;
    },

    getAnswerOfLesson(lesson, answer) {
      if (answer) {
        // let scorall = answer.result.filter((ans) => ans.lesson_id === lesson.id);
        let scor = answer.result.find(
          (answer) => answer.lession_id == lesson.id
        );

        // let scor = answer.result.forEach(element => {
        //   if (element.lession_id == lesson.id)
        // });
        return scor;
      } else {
        return null;
      }
    },
    // getAnswerOfLessonbyid(lesson, answer) {
    //   if (answer) {
    //     let count = 0;
    //     answer.result.forEach(element => {
    //       if (element.lession_id == lesson.id)
    //       count++; // เพิ่มค่า count เมื่อเงื่อนไขเป็นจริง
    //     });
    //     return count;
    //   } else {
    //     return null;
    //   }
    // },
    getAnswerOfLessonbyid(lesson, answer) {
      if (answer) {
        let count = 0;
        // let lessonIdCountMap = {}; // ใช้เก็บจำนวน lesson_id ที่เห็นเข้ากันไป
        answer.result.forEach((element) => {
          if (element.lession_id == lesson.id) {
            // count++; // เพิ่มค่า count เมื่อเงื่อนไขเป็นจริง
            count = element.answer_count;
            // // เพิ่มหรือเพิ่มค่า lesson_id เข้าไปใน Map
            // if (lessonIdCountMap[element.lession_id]) {
            //   lessonIdCountMap[element.lession_id]++;
            // } else {
            //   lessonIdCountMap[element.lession_id] = 1;
            // }
          }
        });
        return count;
      } else {
        return null;
      }
    },

    getMaxQuestion(lesson, answer) {
      let maxScroll = 0;
      if (answer) {
        const answerSet = answer.result.find(
          (answer) => answer.lession_id == lesson.id
        );
        maxScroll =
          answerSet.question_set.max_show_question ?? answerSet.max_score;
        return maxScroll;
      } else {
        return maxScroll;
      }
    },
    async lessonDetail(lesson, courseId, lessonProgress) {
      if (!this.courseStatus) {
        this.goToSubScribe();
        return;
      }

      if (this.preTestCheck(lesson)) {
        return;
      }
      let path = `/lessons`;
      // lessonProgress เป็น array ของ progress ทุกบทเรียน -> ต้องหา record ของบทเรียนนี้ก่อน
      const record = Array.isArray(lessonProgress)
        ? lessonProgress.find((p) => p.lesson_id == lesson.id)
        : lessonProgress;
      let progress = record ? record.lesson_time_sec : 0;
      await this.$router.push({
        path: path,
        query: { courseId: courseId, lessonId: lesson.id, sec: progress },
      });
    },
    downloadFile(link) {
      if (!this.courseStatus) {
        this.goToSubScribe();
        return;
      }

      window.open(link, "_blank");
    },
    numtest(repeatable, repeat_number, alldata) {
      if (repeatable == 0) {
        if (repeat_number == 0) {
          return false;
        } else {
          if (repeat_number <= alldata) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    goToSubScribe() {
      if (!this.userData.id) {
        this.$router.push({
          path: "/login",
        });
      } else {
        alert("เนื้อหาส่วนนี้ สำหรับผู้ที่ลงทะเบียนเรียนเท่านั้น");
      }
    },
    // eslint-disable-next-line no-unused-vars
    async goToQuiz(quizId, answerQuestion, repeatable, repeat_number, alldata) {
      //  
      let path = `/quiz`;
      await this.$router.push({
        path: path,
        query: { id: quizId.id, enrollId: this.courseStatus.enroll_id },
      });
    },
    convertTominute(minute) {
      if (minute) {
        return `${minute} นาที`;
      } else {
        return "";
      }
    },
    postTestCheck(questionSet) {
      // console.log("questionSet", questionSet);
      if (!questionSet) {
        return false;
      }

      if (questionSet.test_type != "posttest") {
        return false;
      }
      if (this.lessonProgress) {
        // console.log(this.lessonProgress);
        let lessonProgress = this.lessonProgress.find(
          (lesson) => lesson.lesson_id == questionSet.lesson_related
        );

        if (!lessonProgress) {
          return false;
        }

        if (lessonProgress.status != 1) {
          return true;
        }
        return false;
      }
      return false;
    },
    preTestCheck(lesson) {
      const questionLesson = this.lessons.filter((l) => l.type == "quiz");

      const questionSet = questionLesson.map((l) => l.question_sets);

      const questionPreMatchLesson = questionSet.find(
        (questionSet) =>
          questionSet.lesson_related == lesson.id &&
          questionSet.test_type == "pretest"
      );

      if (!questionPreMatchLesson) {
        return false;
      }


      if (this.answerCourse) {
        const answer = this.answerCourse.result.find(
          (answer) => answer.lession_id == questionPreMatchLesson.lesson_id
        );
        if (!answer) {
          return true;
        }

        return false;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.btn-outline-light {
  border: none !important;
}
</style>
